<template>
  <div class="home antialiased font-sans  flex flex-col h-full">
    <Topbar v-if="showTopbar" />
    <router-view v-if="hasLoaded"></router-view>
    <div class="text-center flex flex-col h-full justify-center" v-else>
      <h1
        class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
      >
        Welcome to Carthike
      </h1>
    </div>
  </div>
</template>

<script>
// import Spinner from "vue-simple-spinner";

// @ is an alias to /src
import Topbar from "@/components/Common/Topbar";

// import ReviewModal from "@/components/Common/ReviewModal";
import { getMessaging, onMessage, isSupported } from "firebase/messaging";

import { isShopifyEmbedded, isMobile } from "@shopify/app-bridge/utilities";
import { Redirect } from "@shopify/app-bridge/actions";

export default {
  name: "Home",
  components: {
    Topbar
    // Spinner
    // ReviewModal,
  },
  data() {
    return {
      showOnboardingModal: false,
      showReviewModal: false,
      totalRecoveredValue: 0,

      hasLoaded: false,
      isMobile: false,
      showTopbar: false
    };
  },
  async created() {
    if (!isShopifyEmbedded()) {
      // this.$router.push({ name: "Login" });
      // return;
    }
    this.isMobile = isMobile();

    this.setMessagesListener();
    const response = await this.$store.dispatch("getConfig");
    if (response.needsOauth && response.oauthUrl) {
      const app = this.$store.getters.getAppBridgeApp;
      const redirect = Redirect.create(app);
      redirect.dispatch(Redirect.Action.REMOTE, response.oauthUrl);
      return;
    }
    this.hasLoaded = true;
    const store = response.store;
    const route = this.$route.path;
    console.log("route", route);
    this.setEmailOnCrisp();

    const shopifyPlan = this.$store.getters.getShopifyPlan;
    if (this.isNotShopifyStaff(shopifyPlan)) {
      this.showTopbar = true;
    }

    if (store && store.isPlanSelected) {
      if (route === "/") {
        this.$router.push({ name: "Overview" });
        return;
      }
    }

    if (store && store.isPlanSelected === false) {
      this.$router.push({ name: "Plan" });
    }

    if (store.hasReviewed === false && this.notShownOnLast7days()) {
      const recoveredValueResponse = await this.$store.dispatch(
        "getTotalRecoveredValue"
      );
      if (
        recoveredValueResponse &&
        recoveredValueResponse.totalRecoveredValue &&
        recoveredValueResponse.totalRecoveredValue > 0
      ) {
        console.log("show review popup", { recoveredValueResponse });
        this.totalRecoveredValue = `${recoveredValueResponse.currency} ${recoveredValueResponse.totalRecoveredValue}`;
        this.showReviewModal = true;
      }
    }
  },
  methods: {
    onModalClose() {
      this.showOnboardingModal = false;
    },
    isNotShopifyStaff(planName) {
      return ["custom", "staff", "staff_business"].indexOf(planName) === -1;
    },

    checkForOnboarding() {
      const config = this.$store.getters.getConfig;
      if (
        config &&
        config.createdAt > 1652433630 &&
        config.hasCompletedOnboarding === false
      ) {
        this.$router.push({ name: "Onboarding" });
      }
    },
    parseJwt(token) {
      var base64Payload = token.split(".")[1];
      var payload = Buffer.from(base64Payload, "base64");
      return JSON.parse(payload.toString());
    },
    async setEmailOnCrisp() {
      const response = await this.$store.dispatch("getUser");
      // eslint-disable-next-line
      if (response && response.user && response.user.email && $crisp) {
        // eslint-disable-next-line
        $crisp.push(["set", "user:email", [response.user.email]]);
        const store = this.$store.getters.getStore;
        const shopifyPlan = this.$store.getters.getShopifyPlan;
        // eslint-disable-next-line
        $crisp.push([
          "set",
          "session:data",
          [
            [
              ["plan", store.plan],
              ["hasReviewed", store.hasReviewed],
              ["manualMessageSent", store.manualMessageSent],
              ["shopOrigin", store.shopOrigin],
              [
                "sendMessagesUsingDesktopApp",
                store.sendMessagesUsingDesktopApp
              ],
              ["storeId", store.id],
              ["shopifyPlan", shopifyPlan]
            ]
          ]
        ]);
      }
    },

    getTokenFromUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
      });
      return params.token;
    },
    async setMessagesListener() {
      try {
        const isMessagingSupported = await isSupported();
        if (isMessagingSupported) {
          const messaging = getMessaging();
          onMessage(messaging, payload => {
            console.log("Message received. ", payload);
            const currentRoute = this.$route;
            if (
              currentRoute.name !== "TeamInboxChat" ||
              (currentRoute.name == "TeamInboxChat" &&
                currentRoute.params.conversationId !=
                  payload.data.conversationId)
            ) {
              var notification = new Notification(payload.data.title, {
                body: payload.data.body,
                data: { conversationId: payload.data.conversationId }
              });
              notification.onclick = event => {
                console.log("notification event", event);
                const target = event.target.data;
                this.$router.push({
                  name: "TeamInboxChat",
                  params: { conversationId: target.conversationId }
                });
              };
            }
            // ...
          });
        }
      } catch (error) {
        console.log("error while setting notifications");
      }
    }
  }
};
</script>
